import 'modern-normalize/modern-normalize.css';
import './src/css/main.scss';
import React from 'react';
import CleanUrls from './src/components/CleanUrls';

require('prismjs/themes/prism-okaidia.css');

export const onClientEntry = () => {};

// ブラウザでのレンダリング時に CleanUrls コンポーネントをラップする
export const wrapPageElement = ({ element }) => {
  return (
    <>
      <CleanUrls />
      {element}
    </>
  );
};
